
import { FloatingFeature } from "@models";
import { AbilityScoreType, RollType } from "@dndModels/Types";

export class Advantage extends FloatingFeature {
  type = ""; // What do they get advantage on
  disadvantage = false; // True if it's disadvantage instead of advantage
  type_detail = "";
  selectable_key = "";
  type_details: string[] = [];
  for_class_id = "";
  formula = ""; // When do they get advantage?  Only worry about the things we track.  Other things are just in description.
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.type = obj.type ? obj.type : "";
      this.disadvantage = obj.disadvantage ? obj.disadvantage : false;
      this.type_detail = obj.type_detail ? obj.type_detail : "";
      this.type_details = obj.type_details ? obj.type_details : [];
      this.formula = obj.formula ? obj.formula : "";
      
      this.selectable_key = obj.selectable_key ? obj.selectable_key : "";
      this.for_class_id = obj.for_class_id ? obj.for_class_id : "";
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.type = obj.type ? obj.type : "";
  //     this.disadvantage = obj.disadvantage ? obj.disadvantage : false;
  //     this.type_detail = obj.type_detail ? obj.type_detail : "";
  //     this.type_details = obj.type_details ? obj.type_details : [];
  //     this.formula = obj.formula ? obj.formula : "";
      
  //     this.selectable_key = obj.selectable_key ? obj.selectable_key : "";
  //     this.for_class_id = obj.for_class_id ? obj.for_class_id : "";
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      type: this.type,
      disadvantage: this.disadvantage,
      type_detail: this.type_detail,
      selectable_key: this.selectable_key,
      type_details: this.type_details,
      formula: this.formula,
      for_class_id: this.for_class_id
    };
  }
  
  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof Advantage) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: Advantage) {
    this.type = copyMe.type;
    this.disadvantage = copyMe.disadvantage;
    this.type_detail = copyMe.type_detail;
    this.selectable_key = copyMe.selectable_key;
    this.type_details = [...copyMe.type_details];
    this.formula = copyMe.formula;
    this.for_class_id = copyMe.for_class_id;
  }

  clone(drop_ids = false): Advantage {
    const new_obj = new Advantage();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

/**
 * This is for the Feat Elven Accuracy.  
 * It makes it so that when they have advantage on a roll in certain situations, 
 * they get to roll 3 d20s and take the highest instead of only 2.
 * 

  Whenever you have advantage on an attack roll 
  using Dexterity, Intelligence, Wisdom, or Charisma, 
  you can reroll one of the dice once.

  In the future this may have additional limits, 
  but I'm not going to worry about it for now.
 */
export class GreaterAdvantage extends FloatingFeature {
  roll_types: RollType[] = [];
  use_ability_scores: AbilityScoreType[] = [];
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.roll_types = obj.roll_types ? obj.roll_types : [];
      this.use_ability_scores = obj.use_ability_scores ? obj.use_ability_scores : [];
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.roll_types = obj.roll_types ? obj.roll_types : [];
  //     this.use_ability_scores = obj.use_ability_scores ? obj.use_ability_scores : [];
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      roll_types: this.roll_types,
      use_ability_scores: this.use_ability_scores
    };
  }
  
  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof GreaterAdvantage) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: GreaterAdvantage) {
    this.roll_types = [...copyMe.roll_types];
    this.use_ability_scores = [...copyMe.use_ability_scores];
  }

  clone(drop_ids = false): GreaterAdvantage {
    const new_obj = new GreaterAdvantage();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

export interface CharacterAdvantage {
  true_id: string;
  advantage: Advantage;
  source_id: string;
  source_type: string;
  source_name: string;
  cfb_id: string;
  cfb_name: string;
  // type_detail: string;
  // type_details: string[];
  // specializations: string[];
}